var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.run.id)?_c('create-run-form',{attrs:{"run-to-copy":_vm.run}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }